import React from "react";
import Button from "../../button/Button";
import useThemeService from "../../../services/theme-service/ThemeService";
import { AddNew } from "../../svg/svgImageList";

interface AddNewButtonProps {
  disabled?: boolean;
  onClick?: () => void;
  buttonText?: string;
}

export default function AddNewButton(props: AddNewButtonProps) {
  const { themeClass } = useThemeService();

  return (
    <Button
      id="add-new"
      onClick={props.onClick}
      disabled={props.disabled}
      icon={{
        svg: AddNew,
        textKey: props.buttonText ? props.buttonText : "AddNewButton.add",
        textClass: "actions-header-button-label",
        className: themeClass(["icon-add-new"]),
      }}
    />
  );
}
